export const MAX_SELECTED_INITIATIVES = 12;
